/**
 * Which stores a person covers.
 *
 * Checkboxes rather than a multi-select, because the answer is usually "one of
 * three" and a multi-select hides both the options and the current answer
 * behind a control you have to open to read. With a handful of branches the
 * whole state is visible at a glance, which is what an access decision wants.
 *
 * Shared by the add dialog and the edit dialog so they cannot drift into
 * describing the same grant two different ways.
 */
export interface StoreOption {
  id: string;
  name: string;
}

export function StoreChecklist({
  idPrefix,
  stores,
  value,
  onChange,
  label = '担当店舗',
}: {
  idPrefix: string;
  stores: StoreOption[];
  value: string[];
  onChange: (next: string[]) => void;
  label?: string;
}) {
  const toggle = (id: string) =>
    onChange(value.includes(id) ? value.filter((each) => each !== id) : [...value, id]);

  if (stores.length === 0) {
    return (
      <p className="notice field--full">
        店舗が登録されていません。先に店舗を追加すると、担当を割り当てられます。
      </p>
    );
  }

  return (
    <div className="field field--full">
      {/*
        A group label, not a <label>: it names a set of checkboxes rather than
        one control, and a label pointing at nothing is worse for a screen
        reader than a heading that says what the group is.
      */}
      <span className="field__label" id={`${idPrefix}-label`}>
        {label}
      </span>
      <div className="storepick" role="group" aria-labelledby={`${idPrefix}-label`}>
        {stores.map((store) => (
          <label key={store.id} className="storepick__item" htmlFor={`${idPrefix}-${store.id}`}>
            <input
              id={`${idPrefix}-${store.id}`}
              type="checkbox"
              checked={value.includes(store.id)}
              onChange={() => toggle(store.id)}
            />
            <span>{store.name}</span>
          </label>
        ))}
      </div>
      {stores.length > 1 && (
        <span className="field__hint">
          複数の店舗を担当できます。選んだ店舗の記事だけを扱えます。
        </span>
      )}
    </div>
  );
}
